import { styled } from 'styled-components';

// Wrapper around the entire component
export const Wrapper = styled.div`
  display: flex;
  justify-content: space-evenly;
  padding: var(--spacing-large);
  width: 100%;
`;
